import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  filter: {
    '=': [
      {
        '@.': '!id',
      },
      {
        '@$': 'subawardId',
      },
    ],
  },
  target: 'ent:!subawards:!subaward',
  quantity: 1,
  selection: {
    if: [
      [
        {
          '=': [
            {
              '@': 'subawardSnapshot',
            },
            null,
          ],
        },
        {
          '{}': {
            type: 'metric',
            content: {
              '{}': {
                name: 'Subaward Risk Score',
                value: {
                  '{}': {
                    emphasis: '-',
                    aside: '/ -',
                  },
                },
              },
            },
          },
        },
      ],
      {
        '@': 'subawardSnapshot',
      },
    ],
  },
  subqueries: {
    subawardSnapshot: {
      ref: {
        attr: 'attr:snap#!subawards#!subaward_risk_survey:!subj',
      },
      target: 'snap:!subawards:!subaward_risk_survey',
      quantity: 1,
      selection: {
        '{}': {
          type: 'metric',
          content: {
            '{}': {
              name: 'Subaward Risk Score',
              event: {
                '{}': {
                  time: {
                    '++': [
                      '(',
                      {
                        '@.': '!when',
                      },
                      ')',
                    ],
                  },
                },
              },
              value: {
                '{}': {
                  aside: {
                    '++': [
                      '/ ',
                      {
                        score: {
                          possible: '*',
                        },
                      },
                    ],
                  },
                  emphasis: {
                    score: '*',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}
